import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DoubleArrow, Check } from '@mui/icons-material';
import { popOver, dacRegions, states } from '../../assets/templates';
import Select from '../ui/Select';
import FlipSwitch from '../ui/FlipSwitch';
import ToggleButton from '../ui/ToggleButton';
import Consumptions from '../../api/consumptions';
import validateRequiredFields, { toInteger } from '../../utilities';

const SelectElectricityCostView = ({
  view,
  setView,
  calculationsData,
  setCalculationsData,
  homeTariff,
  chargesbyRegion,
  setChargesbyRegion,
}) => {
  const [isNextStepAvailable, setIsNextStepAvailable] = useState(false);
  const [validateSubmit, setValidateSubmit] = useState(false);

  const getChargesByRegion = async (rate) => {
    setCalculationsData({
      ...calculationsData,
      electricity: {
        ...calculationsData.electricity,
        rate,
        electricityTariff: {},
      },
    });
    await Consumptions.getChargesByRegion(rate)
      .then((res) => {
        setChargesbyRegion(res?.cargos);
      })
      .catch((err) => err);
  };

  useEffect(() => {
    if (calculationsData?.electricity?.electricityCostType === 'manual'
    || !calculationsData?.electricity?.electricityCostType) return;

    if (calculationsData?.electricity?.isDacNeeded && !calculationsData?.electricity?.dac) return;

    const electricityCost = calculationsData?.electricity?.isDacNeeded
      ? toInteger((calculationsData.electricity?.dac?.dacPrice || 0)
      * calculationsData.design.kWhConsumedByDesign * calculationsData.currentCurrencyRate, 2)
      : toInteger((calculationsData.electricity?.electricityTariff?.basico || 0)
        * calculationsData.design.kWhConsumedByDesign * calculationsData.currentCurrencyRate, 2);

    setCalculationsData({
      ...calculationsData,
      electricity: {
        ...calculationsData.electricity,
        electricityCostPerDesign: electricityCost,
      },
    });

    if (isNextStepAvailable) return;
    setIsNextStepAvailable(true);
  }, [calculationsData.electricity?.electricityTariff,
    calculationsData?.electricity?.dac, calculationsData?.electricity?.isDacNeeded,
    calculationsData?.electricity?.electricityCostType]);

  useEffect(() => {
    setValidateSubmit(validateRequiredFields(document.querySelectorAll('[required]')));
  }, [calculationsData.electricity]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        setView(view + 1);
      }}
      className="main-container"
      style={{ position: 'relative' }}
    >

      <button
        onClick={() => setView(view - 1)}
        id="button"
        className="simple-button"
        type="button"
        style={{ position: 'absolute', top: '0', left: '0' }}
      >
        <DoubleArrow sx={{ transform: 'rotate(180deg)' }} />
        Paso anterior
      </button>

      {((isNextStepAvailable || calculationsData?.electricity?.electricityCostPerDesign >= 0)
      && calculationsData?.electricity?.electricityCostType)
      && (
      <button
        id="button"
        className="simple-button"
        type="submit"
        data-available={validateSubmit}
        data-disabled={!validateSubmit}
        style={{ position: 'absolute', top: '0', right: '0' }}
      >
        <DoubleArrow />
        Siguiente paso
      </button>
      )}

      <div style={{ maxWidth: '600px', margin: '50px auto 30px auto' }} className="appear aligned-items justify-items">
        <ToggleButton
          value={calculationsData?.electricity?.electricityCostType === 'CFE'}
          setValue={() => setCalculationsData({
            ...calculationsData,
            electricity: {
              ...calculationsData.electricity,
              electricityCostType: 'CFE',
            },
          })}
          style={{ marginRight: '50px' }}
          textLabel="Definir costo por Tarifa CFE"
        />
        <ToggleButton
          value={calculationsData?.electricity?.electricityCostType === 'manual'}
          setValue={() => setCalculationsData({
            ...calculationsData,
            electricity: {
              ...calculationsData.electricity,
              electricityCostType: 'manual',
            },
          })}
          textLabel="Definir costo manualmente"
        />
      </div>

      {calculationsData?.electricity?.electricityCostType === 'CFE'
      && (
      <>
        <div className="appear icon-wrapper" style={{ marginTop: '30px', textAlign: 'center' }}>
          <p className="appear">Su tarifa es de alto consumo (DAC)?</p>
          <div data-title={popOver[42]}>
            <img
              alt="icon"
              src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
            />
          </div>
          <div className="justify-align-items">
            <p style={{ marginRight: '20px' }}>No</p>
            <FlipSwitch
              style={{ margin: '10px auto' }}
              isOn={!calculationsData?.electricity?.isDacNeeded}
              setIsOn={(value) => setCalculationsData({
                ...calculationsData,
                electricity: {
                  ...calculationsData.electricity,
                  isDacNeeded: !value,
                },
              })}
            />
            <p style={{ marginLeft: '20px' }}>Si</p>
          </div>
        </div>
        {!calculationsData?.electricity?.isDacNeeded
        && (
        <div style={{ margin: '50px auto 30px auto' }} className="appear item-container icon-wrapper">
          <p style={{ margin: '0' }}>
            {(chargesbyRegion?.length > 0)
              && (<Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
            Seleccione el tipo de tarifa
          </p>
          <div data-title={popOver[35]}>
            <img
              alt="icon"
              src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
            />
          </div>
          <Select
            value={calculationsData?.electricity?.rate || ''}
            setValue={(rate) => getChargesByRegion(rate)}
            options={homeTariff}
            property="id_tarifa"
            required
            placeholder="Seleccionar opcion"
          />
          {(chargesbyRegion?.length > 0 || calculationsData?.electricity?.electricityTariff)
          && (
          <div className="appear icon-wrapper">
            <p style={{ margin: '20px 0 0 0' }}>
              {(calculationsData?.electricity?.electricityTariff)
                && (<Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
              Seleccione el mes actual
            </p>
            <div data-title={popOver[3]}>
              <img
                alt="icon"
                src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
              />
            </div>
            <Select
              value={calculationsData?.electricity?.electricityTariff?.id_cargo || ''}
              setValue={(value) => setCalculationsData({
                ...calculationsData,
                electricity: {
                  ...calculationsData.electricity,
                  electricityTariff: chargesbyRegion?.length > 0
                  && chargesbyRegion.filter((region) => region.id_cargo === value)[0],
                },
              })}
              options={chargesbyRegion}
              property="id_cargo"
              placeholder="Seleccionar opcion"
              required
            />
          </div>
          )}
        </div>
        )}

        {calculationsData?.electricity?.isDacNeeded === true
        && (
        <div style={{ margin: '50px auto 0 auto' }} className="appear item-container icon-wrapper">
          <p style={{ margin: '0' }}>
            {(calculationsData?.electricity?.dac?.id_tarifa)
              && (<Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
            Seleccione el estado donde se encuentra
          </p>
          <Select
            value={calculationsData?.electricity?.dacState || ''}
            setValue={(value) => setCalculationsData({
              ...calculationsData,
              electricity: {
                ...calculationsData.electricity,
                dacState: value || '',
                dac: dacRegions.tarifas.filter((tariff) => tariff.estados.includes(value))[0],
              },
            })}
            options={states}
            required
            placeholder="Seleccionar opcion"
          />
          <p style={{ margin: '20px 0 0 0' }}>
            {(calculationsData?.electricity?.dac?.id_tarifa)
              && (<Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
            Esta es la region a la que corresponde su estado
          </p>
          <div data-title={popOver[4]}>
            <img
              alt="icon"
              src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
            />
          </div>
          <input
            className="select"
            value={calculationsData?.electricity?.dac?.id_tarifa || ''}
            placeholder="Seleccionar opcion"
            disabled
            required
          />
        </div>
        )}
      </>
      )}

      {calculationsData?.electricity?.electricityCostType === 'manual'
      && (
      <div className="appear icon-wrapper item-container">
        <p style={{ margin: '0' }}>
          {calculationsData?.electricity?.electricityCostPerDesign > 0
          && (<Check className="appear" sx={{ color: 'green', fontSize: '15px' }} />)}
          Asignar costo de electricidad por pieza
        </p>
        <div data-title={popOver[41]}>
          <img
            alt="icon"
            src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
          />
        </div>
        <div style={{ position: 'relative', width: '100%' }}>
          <input
            placeholder="60"
            style={{ padding: '3px 80px 3px 25px' }}
            className="select"
            type="number"
            required
            value={toInteger(calculationsData?.electricity?.electricityCostPerDesign, 2) || ''}
            onChange={(e) => setCalculationsData({
              ...calculationsData,
              electricity: {
                ...calculationsData.electricity,
                electricityCostPerDesign: Number(e.target.value),
              },
            })}
          />
          <p className="start-input-icon">{calculationsData.currentCurrency.symbol}</p>
        </div>
      </div>
      )}

      {(calculationsData?.electricity?.electricityCostPerDesign >= 0
      && calculationsData?.electricity?.electricityCostType)
      && (
      <div
        style={{ display: 'flex', margin: '30px auto 0 auto' }}
        className="appear icon-wrapper item-container-contrast"
      >
        <div className="aligned-items" style={{ width: '100%' }}>
          <p style={{ margin: '0' }}>Costo total por consumo electrico</p>
          <div data-title={popOver[43]}>
            <img
              alt="icon"
              src="https://ramonsgt.github.io/calculadora-de-inversion-sagaon/assets/icons/question-mark.svg"
            />
          </div>
        </div>
        <div style={{ position: 'relative', width: '100%' }}>
          <input
            id="electricity-cost-input"
            placeholder="60"
            style={{ padding: '3px 40px 3px 25px', height: 'auto' }}
            className="select"
            type="number"
            disabled
            value={calculationsData?.electricity?.electricityCostPerDesign.toFixed(2)}
          />
          <p className="start-input-icon">{calculationsData.currentCurrency.symbol}</p>
        </div>
      </div>
      )}

    </form>
  );
};

SelectElectricityCostView.propTypes = {
  view: PropTypes.number.isRequired,
  setView: PropTypes.func.isRequired,
  calculationsData: PropTypes.shape({
    currentCurrencyRate: PropTypes.number,
    currentCurrency: PropTypes.shape({
      currency: PropTypes.string,
      currencyCode: PropTypes.string,
      country: PropTypes.string,
      symbol: PropTypes.string,
    }),
    electricity: PropTypes.shape({
      dacTariff: PropTypes.shape({
        id_tarifa: PropTypes.string,
        tipo: PropTypes.string,
        estados: PropTypes.string,
        cargos: PropTypes.arrayOf(PropTypes.string),
        uso_dac: PropTypes.number,
      }),
      electricityCostPerDesign: PropTypes.number,
      electricityCostType: PropTypes.string,
      electricityTariff: PropTypes.shape({
        basico: PropTypes.number,
        excedente: PropTypes.number,
        fijo: PropTypes.number,
        id_cargo: PropTypes.string,
        intermedio: PropTypes.number,
        intermedio_alto: PropTypes.number,
        kwh_basico: PropTypes.number,
        kwh_excedente: PropTypes.number,
        kwh_intermedio: PropTypes.number,
        kwh_intermedio_alto: PropTypes.number,
        mes: PropTypes.string,
        region: PropTypes.arrayOf(PropTypes.string),
      }),
      dacState: PropTypes.string,
      dac: PropTypes.shape({
        id_tarifa: PropTypes.string,
        dacPrice: PropTypes.number,
      }),
      isDacNeeded: PropTypes.bool,
      rate: PropTypes.string,
    }),
    design: PropTypes.shape({
      kWhConsumedByDesign: PropTypes.number,
    }),
  }).isRequired,
  setCalculationsData: PropTypes.func.isRequired,
  homeTariff: PropTypes.arrayOf(PropTypes.shape({
    cargos: PropTypes.arrayOf(PropTypes.string),
    id_tarifa: PropTypes.string,
    tipo: PropTypes.string,
    uso_dac: PropTypes.number,
  })).isRequired,
  chargesbyRegion: PropTypes.arrayOf(PropTypes.shape({
    basico: PropTypes.number,
    excedente: PropTypes.number,
    fijo: PropTypes.number,
    id_cargo: PropTypes.string,
    intermedio: PropTypes.number,
    intermedio_alto: PropTypes.number,
    kwh_basico: PropTypes.number,
    kwh_excedente: PropTypes.number,
    kwh_intermedio: PropTypes.number,
    kwh_intermedio_alto: PropTypes.number,
    mes: PropTypes.string,
    region: PropTypes.arrayOf(PropTypes.string),
  })).isRequired,
  setChargesbyRegion: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => (
  {
    view: state.view,
    calculationsData: state.calculationsData,
    chargesbyRegion: state.chargesbyRegion,
  });

const mapDispatchToProps = (dispatch) => ({
  setView: (values) => dispatch({
    type: 'SET_VIEW',
    payload: values,
  }),
  setCalculationsData: (values) => dispatch({
    type: 'SET_CALCULATIONS_DATA',
    payload: values,
  }),
  setChargesbyRegion: (values) => dispatch({
    type: 'SET_CHARGES_BY_REGION',
    payload: values,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectElectricityCostView);
